import { useMediaQuery } from "./auth-service-tools571.js";

function useReducedMotion(initialValue, options) {
  return useMediaQuery("(prefers-reduced-motion: reduce)", initialValue, options);
}

export { useReducedMotion };